import { price, jobOfferId, employeeId, desc } from "./validations";

export const ApplicationValidate = {
  price,
  jobOfferId,
  employeeId,
  desc,
};
